import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { toast } from 'sonner';
import i18n from '@/i18n/config';

interface ProtectedRouteProps {
  children: ReactNode;
  requireAdmin?: boolean;
  allowModerator?: boolean;
}

export function ProtectedRoute({ 
  children, 
  requireAdmin = false,
  allowModerator = false 
}: ProtectedRouteProps) {
  const { user, isAdmin, isModerator, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-blueprint-bg flex items-center justify-center">
        <div className="text-blueprint-text">{i18n.t('auth:loading')}</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" replace />;
  }

  if (requireAdmin) {
    const hasAccess = isAdmin || (allowModerator && isModerator);
    if (!hasAccess) {
      toast.error(i18n.t('errors:noPermission'));
      return <Navigate to="/" replace />;
    }
  }

  return <>{children}</>;
}
